import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IDropdownInput {
    label?: string,
    name: string,
    defaultValue?: string | number,
    control: any,
    error?: string
    options: any
    optionLabel: string,
    placeholder?: string,
    completeMethod: (event: { query: string }) => void,
    func?: () => void,
    required?: boolean,
    column?: number,
    icon?: string,
    iconbg?: string,
    disabled?: boolean
}

export const JVDropdownInput = (props: IDropdownInput) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <div className="p-inputgroup">
                <Controller name={props.name} control={props.control} defaultValue={props.defaultValue} render={({ field, fieldState }) => (
                    <AutoComplete disabled={props.disabled} {...field} suggestions={props.options} completeMethod={props.completeMethod} field={props.optionLabel} forceSelection value={field.value} placeholder={props.placeholder} className={classNames({ 'p-invalid': fieldState.invalid })} />
                )} />
                {props.func && <Button disabled={props.disabled} type="button" onClick={props.func} icon={props.icon === undefined ? "pi pi-plus" : `pi pi-${props.icon}`} className={props.iconbg === undefined ? "p-button-success" : `p-button-${props.iconbg}`} />}
            </div>
            <small className="p-error" >{props.error}</small>
        </div>
    )
}